// extracted by mini-css-extract-plugin
export default {"main":"j8MsUk","avatar":"cMpQkr","small":"QfHjMB"};